import { icons } from 'src/assets/iconDef/icon.def';

export const billingMenuDef = [
  {
    "name": "menu.billing",
    "icon": "fa fa-key",
    "data": {
      "nav_url": "billingdashboard_format_m"
    },
    "children": [
      {
        "name": "menu.billing_dashboard",
        "resource": "billingdashboard_format",
        "icon": "fa fa-user",
        "url": "billingdashboard_format",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "resource": "authority_clearence",
        "url": "authority_clearence",
        "auto_crud": true,
      },
      {
        "name": "Finance Clearance",
        "resource": "ot_finance_format",
        "icon": "fa fa-user",
        "url": "ot_finance_format",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "Finance Clearance",
        "resource": "ot_finance_format_op",
        "icon": "fa fa-user",
        "url": "ot_finance_format_op",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "Finance Clearance",
        "resource": "ot_finance_format_er",
        "icon": "fa fa-user",
        "url": "ot_finance_format_er",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "Finance Clearance",
        "resource": "ot_finance_format_dc",
        "icon": "fa fa-user",
        "url": "ot_finance_format_dc",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "menu.charity_details",
        "resource": "charity_details_tab",
        "icon": "fa fa-user",
        "url": "charity_details_tab",
        "auto_crud": true,
        "breadcrumb": "Charity Details",
        "check_permission": false
      },
      {
       "name": "menu.charity_request",
       "resource": "charity_approved_request",
        "icon": "fa fa-user",
        "url": "charity_approved_request",
        "auto_crud": true,
        "breadcrumb": "Approved  Requests",
        "showMenu": false
      },
      {
        "name": "menu.charity_rejected",
        "resource": "charity_rejected_request",
        "icon": "fa fa-user",
        "url": "charity_rejected_request",
        "auto_crud": true,
        "breadcrumb": "Rejected Requests",
        "showMenu": false
      },
      {
        "name": "menu.charity_all_requests",
        "resource": "charity_all_requests",
        "icon": "fa fa-user",
        "url": "charity_all_requests",
        "auto_crud": true,
        "breadcrumb": "All Requests",
        "showMenu": false
      },
{
       "name": "menu.charity_raised_request",
       "resource": "charity_raised_request",
        "icon": "fa fa-user",
        "url": "charity_raised_request",
        "auto_crud": true,
        "breadcrumb": "Charity Raised Request",
        "showMenu": false
      },
      {
         "name": "menu.charity_in_progress",
       "resource": "charity_in_progress",
        "icon": "fa fa-user",
        "url": "charity_in_progress",
        "auto_crud": true,
        "breadcrumb": "Charity In Progress",
        "showMenu": false
      },
      {
        "name": "menu.charity_request_details",
        "resource": "charity_request_details",
        "icon": "fa fa-user",
        "url": "charity_request_details",
        "auto_crud": true,
        "breadcrumb": "Charity Request",
        "showMenu": false
      },
      {
        "name": "menu.charity_patient_list",
        "resource": "charity_patient_list",
        "icon": "fa fa-user",
        "url": "charity_patient_list",
        "auto_crud": true,
        "breadcrumb": "Select Patient",
        "showMenu": false
      },
            {
        "name": "menu.charity_admitted_request_details",
        "resource": "charity_admitted_request_details",
        "icon": "fa fa-user",
        "url": "charity_admitted_request_details",
        "auto_crud": true,
        "breadcrumb": "Charity Request",
        "showMenu": false
      },
      {
         "name": "menu.charity_expired",
       "resource": "charity_expired_request",
        "icon": "fa fa-user",
        "url": "charity_expired_request",
        "auto_crud": true,
        "breadcrumb": "Expired Requests",
        "showMenu": false
      },
      {
        "name": "menu.charity_cancelled",
        "resource": "charity_cancelled_request",
        "icon": "fa fa-user",
        "url": "charity_cancelled_request",
        "auto_crud": true,
        "breadcrumb": "Cancelled Requests",
        "showMenu": false
      },
      {
        "name": "menu.charity_completed",
        "resource": "charity_completed_request",
        "icon": "fa fa-user",
        "url": "charity_completed_request",
        "auto_crud": true,
        "breadcrumb": "Completed Requests",
        "showMenu": false
      },
      {
        "name": "OT Finance Clearance",
        "resource": "ot_finance_surgery",
        "icon": "fa fa-user-md",
        "url": "ot_finance_surgery",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "Cathlab Finance Clearance",
        "resource": "cathlab_finance_surgery",
        "icon": "fa fa-user-md",
        "url": "cathlab_finance_surgery",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "OT Finance Clearance Completed",
        "resource": "ot_finance_surgery_completed",
        "icon": "fa fa-user-md",
        "url": "ot_finance_surgery_completed",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "Cathlab Finance Clearance Completed",
        "resource": "cathlab_finance_surgery_completed",
        "icon": "fa fa-user-md",
        "url": "cathlab_finance_surgery_completed",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "ot_finance_completed_surgery_op",
        "resource": "ot_finance_completed_surgery_op",
        "icon": "fa fa-user-md",
        "url": "ot_finance_completed_surgery_op",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "cathlab_finance_completed_surgery_op",
        "resource": "cathlab_finance_completed_surgery_op",
        "icon": "fa fa-user-md",
        "url": "cathlab_finance_completed_surgery_op",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "finance_clearance_completed_ot",
        "resource": "finance_clearance_completed_ot",
        "icon": "fa fa-user-md",
        "url": "finance_clearance_completed_ot",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "finance_clearance_completed_cathlab",
        "resource": "finance_clearance_completed_cathlab",
        "icon": "fa fa-user-md",
        "url": "finance_clearance_completed_cathlab",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.billing_dashboard",
        "resource": "billing_details_billingdashboard",
        "icon": "fa fa-user",
        "url": "billing_details_billingdashboard",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "showMenu": false
      },
      {
        "name": "menu.billing_payer_authorized",
        "resource": "billing_payer_authorized",
        "icon": "fa fa-user",
        "url": "billing_payer_authorized",
        "auto_crud": true,
        "breadcrumb": "Billing Payer Authorized",
        "showMenu": false
      },
      {
        "name": "menu.patient_notes",
        "resource": "patient_notes",
        "icon": "fa fa-user",
        "url": "patient_notes",
        "auto_crud": true,
        "breadcrumb": "Patient Notes",
        "showMenu": false
      },
      {
        "name": "menu.billing_details",
        "resource": "billing_details",
        "icon": "fa fa-user",
        "url": "billing_details",
        "auto_crud": true,
        "breadcrumb": "Billing Details",
        "showMenu": false
      },
      {
        "name": "menu.inpatient",
        "resource": "billing_details_in_patient",
        "icon": "fa fa-user",
        "url": "billing_details_in_patient",
        "auto_crud": true,
        "breadcrumb": "In-Patient",
        "showMenu": false
      },
      {
        "name": "menu.ip_billing_main",
        "resource": "ip_billing_main_ip",
        "icon": "fa fa-user",
        "url": "ip_billing_main_ip",
        "auto_crud": true,
        "breadcrumb": "IP Billing Main",
        "showMenu": false
      },
      {
        "name": "menu.settled_billing_ip",
        "resource": "settled_billing_ip",
        "icon": "fa fa-user",
        "url": "settled_billing_ip",
        "auto_crud": true,
        "breadcrumb": "Settled Billing Main",
        "showMenu": false
      },
      {
        "name": "menu.ip_billing_maindaycare",
        "resource": "ip_billing_main_daycare",
        "icon": "fa fa-user",
        "url": "ip_billing_main_daycare",
        "auto_crud": true,
        "breadcrumb": "IP Billing Main-Daycare",
        "showMenu": false
      },
      {
        "name": "menu.discharged_patients",
        "resource": "billing_details_discharged_patients",
        "icon": "fa fa-user",
        "url": "billing_details_discharged_patients",
        "auto_crud": true,
        "breadcrumb": "Discharged Patients",
        "showMenu": false
      },
      {
        "name": "menu.spilit_billing_details_discount",
        "resource": "spilit_billing_details_discount",
        "icon": "fa fa-user",
        "url": "spilit_billing_details_discount",
        "auto_crud": true,
        "breadcrumb": "Discharged Patients",
        "showMenu": false
    },
    {
      "name": "menu.split_view",
      "resource": "split_view",
      "icon": "fa fa-user",
      "url": "split_view",
      "auto_crud": true,
      "breadcrumb": "Discharged Patients",
      "showMenu": false
  },
  {
    "name": "menu.ip_view_detail",
    "resource": "ip_view_detail",
    "icon": "fa fa-user",
    "url": "ip_view_detail",
    "auto_crud": true,
    "breadcrumb": "Discharged Patients",
    "showMenu": false
},
      {
        "name": "menu.patient_notes",
        "resource": "patient_notes",
        "icon": "fa fa-user",
        "url": "patient_notes",
        "auto_crud": true,
        "breadcrumb": "Patient Notes",
        "showMenu": false
      },
      {
        "name": "menu.alerts",
        "resource": "patient_notes_list",
        "icon": "fa fa-user",
        "url": "patient_notes_list",
        "auto_crud": true,
        "breadcrumb": "Alerts",
        "showMenu": false
      },
      {
        "name": "menu.room_rent",
        "resource": "billing_item_room_rent",
        "icon": "fa fa-user",
        "url": "billing_item_room_rent",
        "auto_crud": true,
        "breadcrumb": "Room Rent",
        "showMenu": false
      },

      {
        name: 'menu.transfer_histrory_tab',
        resource: 'transfer_histrory_tab',
        icon: 'fa fa-user',
        url: 'transfer_histrory_tab',
        auto_crud: true,
        showMenu: false
      },
      {
        name: 'menu.bed_transfer_history_tab',
        resource: 'bed_transfer_history_tab',
        icon: 'fa fa-user',
        url: 'bed_transfer_history_tab',
        auto_crud: true,
        showMenu: false
      },
      {
        name: 'menu.doctor_transfer_history',
        resource: 'doctor_transfer_history',
        icon: 'fa fa-user',
        url: 'doctor_transfer_history',
        auto_crud: true,
        showMenu: false
      },
      {
        name: 'menu.ip_settlement_ip',
        resource: 'ip_settlement_ip',
        icon: 'fa fa-user',
        url: 'ip_settlement_ip',
        auto_crud: false,
        showMenu: true
      },
      {
        name: 'menu.common_service_type_billing',
        resource: 'common_service_type_billing',
        icon: 'fa fa-user',
        url: 'common_service_type_billing',
        auto_crud: false,
        showMenu: true
      },
      {
        "name": "menu.pathology",
        "resource": "billing_item_pathology",
        "icon": "fa fa-user",
        "url": "billing_item_pathology",
        "auto_crud": true,
        "breadcrumb": "Pathology",
        "showMenu": false
      },
      {
        "name": "menu.radiology",
        "resource": "billing_item_radiology",
        "icon": "fa fa-user",
        "url": "billing_item_radiology",
        "auto_crud": true,
        "breadcrumb": "Radiology",
        "showMenu": false
      },
      {
        "name": "menu.pulmonology",
        "resource": "billing_item_pulmonology",
        "icon": "fa fa-user",
        "url": "billing_item_pulmonology",
        "auto_crud": true,
        "breadcrumb": "Pulmonology",
        "showMenu": false
      },
      {
        "name": "menu.administration",
        "resource": "billing_item_administration",
        "icon": "fa fa-user",
        "url": "billing_item_administration",
        "auto_crud": true,
        "breadcrumb": "Administration",
        "showMenu": false
      },
      {
        "name": "menu.cardiology",
        "resource": "billing_item_cardiology",
        "icon": "fa fa-user",
        "url": "billing_item_cardiology",
        "auto_crud": true,
        "breadcrumb": "Cardiology",
        "showMenu": false
      },
      {
        "name": "menu.neurology",
        "resource": "billing_item_neurology",
        "icon": "fa fa-user",
        "url": "billing_item_neurology",
        "auto_crud": true,
        "breadcrumb": "Neurology",
        "showMenu": false
      },
      {
        "name": "menu.nuclear_medicine",
        "resource": "billing_item_nuclear_medicine",
        "icon": "fa fa-user",
        "url": "billing_item_nuclear_medicine",
        "auto_crud": true,
        "breadcrumb": "Nuclear Medicine",
        "showMenu": false
      },
      {
        "name": "menu.refund_detail",
        "resource": "refund_detail",
        "icon": "fa fa-user",
        "url": "refund_detail",
        "auto_crud": true,
        "breadcrumb": "Refund Detail",
        "showMenu": false
      },
      {
        "name": "menu.form_sixty",
        "resource": "form_sixty",
        "icon": "fa fa-user",
        "url": "form_sixty",
        "auto_crud": true,
        "application": "billing",
        "showMenu": false
      },
      {
        "name": "menu.miscellaneous",
        "resource": "billing_item_miscllaneous",
        "icon": "fa fa-user",
        "url": "billing_item_miscllaneous",
        "auto_crud": true,
        "breadcrumb": "Miscellaneous",
        "showMenu": false
      },
      {
        "name": "menu.addendum",
        "resource": "addendum_billing_item",
        "icon": "fa fa-user",
        "url": "addendum_billing_item",
        "auto_crud": true,
        "breadcrumb": "Addendum",
        "showMenu": false
      },
      {
        "name": "menu.addendumdetails",
        "resource": "addendum_billing_details",
        "icon": "fa fa-user",
        "url": "addendum_billing_details",
        "auto_crud": true,
        "breadcrumb": "AddendumDetails",
        "showMenu": false
      },
      {
        "name": "menu.addendumview",
        "resource": "addendum_view",
        "icon": "fa fa-user",
        "url": "addendum_view",
        "auto_crud": true,
        "breadcrumb": "Addendumview",
        "showMenu": false
      },
      {
        "name": "menu.pharmacy",
        "resource": "billing_item_pharmacy",
        "icon": "fa fa-user",
        "url": "billing_item_pharmacy",
        "auto_crud": true,
        "breadcrumb": "Pharmacy",
        "showMenu": false
      },
      {
        "name": "menu.pharmacy",
        "resource": "billing_item_alacart",
        "icon": "fa fa-user",
        "url": "billing_item_alacart",
        "auto_crud": true,
        "breadcrumb": "Pharmacy",
        "showMenu": false
      },
      {
        "name": "menu.surgery___procedure",
        "resource": "billing_item_surgery_procedure",
        "icon": "fa fa-user",
        "url": "billing_item_surgery_procedure",
        "auto_crud": true,
        "breadcrumb": "Surgery & procedure",
        "showMenu": false
      },
      {
        "name": "menu.package",
        "resource": "billing_item_package",
        "icon": "fa fa-user",
        "url": "billing_item_package",
        "auto_crud": true,
        "breadcrumb": "Package",
        "showMenu": false
      },
      {
        "name": "menu.package_exclusion_list",
        "resource": "package_exclusion_list",
        "icon": "fa fa-user",
        "url": "package_exclusion_list",
        "auto_crud": true,
        "breadcrumb": "Package",
        "showMenu": false
      },
      {
        "name": "menu.package_inclusion_list",
        "resource": "package_inclusion_list",
        "icon": "fa fa-user",
        "url": "package_inclusion_list",
        "auto_crud": true,
        "breadcrumb": "Package",
        "showMenu": false
      },
      {
        "name": "menu.deposit",
        "resource": "deposit",
        "icon": "fa fa-user",
        "url": "/payment/deposit",
        "auto_crud": true,
        "breadcrumb": "Deposit",
        "redirect": true
      },
      {
        "name": "menu.billing_payer_details",
        "resource": "billingpayer_details",
        "icon": "fa fa-user",
        "url": "billingpayer_details",
        "auto_crud": true,
        "breadcrumb": "Billing Payer Details",
        "showMenu": false
      },
      {
        "name": "menu.remarks",
        "resource": "patient_billing_remark",
        "icon": "fa fa-user",
        "url": "patient_billing_remark",
        "auto_crud": true,
        "breadcrumb": "Remarks",
        "showMenu": false
      },
      {
        "name": "menu.pending_services",
        "resource": "billing_item_pending",
        "icon": "fa fa-user",
        "url": "billing_item_pending",
        "auto_crud": true,
        "breadcrumb": "Pending Services",
        "showMenu": false
      },
      {
        "name": "menu.pending_equipments",
        "resource": "billing_equipment_pending",
        "icon": "fa fa-user",
        "url": "billing_equipment_pending",
        "auto_crud": true,
        "breadcrumb": "Pending Equipments",
        "showMenu": false
      },
      {
        "name": "menu.package_details",
        "resource": "billing_package_details",
        "icon": "fa fa-user",
        "url": "billing_package_details",
        "auto_crud": true,
        "breadcrumb": "Package Details",
        "showMenu": false
      },
      {
        "name": "menu.sponsor_ip",
        "resource": "sponsor_ip",
        "icon": "fa fa-user",
        "url": "billing_package_details",
        "auto_crud": true,
        "breadcrumb": "Sponsor Details",
        "showMenu": false
      },
      {
        "name": "menu.consultation",
        "resource": "billing_item_consultation",
        "icon": "fa fa-user",
        "url": "billing_item_consultation",
        "auto_crud": true,
        "breadcrumb": "Consultation",
        "showMenu": false
      },
      {
        "name": "menu.biiling_main",
        "resource": "billing_format_ip",
        "icon": "fa fa-user",
        "url": "billing_format_ip",
        "auto_crud": true,
        "breadcrumb": "billing",
        "showMenu": false,
        "check_permission": false
      },
      {
        "name": "menu.billing_main",
        "resource": "settled_format_ip",
        "icon": "fa fa-user",
        "url": "settled_format_ip",
        "auto_crud": true,
        "breadcrumb": "billing",
        "showMenu": false,
        "check_permission": false
      },
      {
        "name": "menu.refund",
        "resource": "refund",
        "icon": "fa fa-user",
        "url": "payment/refund",
        "auto_crud": true,
        "breadcrumb": "Refund"
      },
      {
        "name": "menu.bill_settlement",
        "resource": "bill_settlement",
        "icon": "fa fa-plus-square",
        "url": "bill_settlement",
        "auto_crud": true,
        "breadcrumb": "bill-settlement",
        "showMenu": false
      },
      {
        "name": "menu.discharged",
        "resource": "discharge",
        "icon": "fa fa-plus-square",
        "url": "discharge",
        "auto_crud": true,
        "breadcrumb": "discharged",
        "showMenu": false
      },
      {
        name: 'menu.open_bill',
        resource: 'open_bill',
        icon: 'fa fa-user',
        url: 'open_bill',
        auto_crud: true,
        breadcrumb: 'Open Bill'
      },
      {
        "name": "menu.discharged",
        "resource": "cancel_discharge",
        "icon": "fa fa-plus-square",
        "url": "cancel_discharge",
        "auto_crud": true,
        "breadcrumb": "discharged",
        "showMenu": false
      },
      {
        "name": "menu.tpa_clearance",
        "resource": "tpa_clearance",
        "icon": "fa fa-plus-square",
        "url": "tpa_clearance",
        "auto_crud": true,
        "breadcrumb": "tpa-clearance",
        "showMenu": false
      },
      {
        "name": "menu.bill_ready",
        "resource": "billReady",
        "icon": "fa fa-plus-square",
        "url": "billReady",
        "auto_crud": true,
        "breadcrumb": "tpa-clearance",
        "showMenu": false
      },
      {
        "name": "menu.billing_history",
        "resource": "billing_history_details",
        "icon": "fa fa-user",
        "url": "billing_history_details",
        "auto_crud": true,
        "breadcrumb": "Billing History",
        "showMenu": false
      },
      {
        "name": "menu.document_billing",
        "resource": "document_billing",
        "icon": "fa fa-user",
        "url": "document_billing",
        "auto_crud": true,
        "breadcrumb": "Documents",
        "showMenu": false
      },
      {
        "name": "menu.transfer_history",
        "resource": "bed_transfer_history",
        "icon": "fa fa-user",
        "url": "bed_transfer_history",
        "auto_crud": true,
        "application": "adt",
        "showMenu": false
      },
      {
        "name": "menu.transfer_history",
        "resource": "doctor_transfer_history",
        "icon": "fa fa-user",
        "url": "doctor_transfer_history",
        "auto_crud": true,
        "application": "adt",
        "showMenu": false
      },
      {
        "name": "menu.billing_item_procedure",
        "resource": "billing_item_procedure",
        "icon": "fa fa-user",
        "url": "billing_item_procedure",
        "auto_crud": true,
        "breadcrumb": "Procedure",
        "showMenu": false
      },
      {
        "name": "menu.billing_item_physiotherapy",
        "resource": "billing_item_physiotherapy",
        "icon": "fa fa-user",
        "url": "billing_item_physiotherapy",
        "auto_crud": true,
        "breadcrumb": "Physiotherepy",
        "showMenu": false
      },
      {
        "name": "menu.billing_item_consumable",
        "resource": "billing_item_consumable",
        "icon": "fa fa-user",
        "url": "billing_item_consumable",
        "auto_crud": true,
        "breadcrumb": "Consumable",
        "showMenu": false
      },
      {
        "name": "menu.billing_item_equipment",
        "resource": "billing_item_equipment",
        "icon": "fa fa-user",
        "url": "billing_item_equipment",
        "auto_crud": true,
        "breadcrumb": "Equipment",
        "showMenu": false
      },
      {
        "name": "menu.billing_item_surgery",
        "resource": "billing_item_surgery",
        "icon": "fa fa-user",
        "url": "billing_item_surgery",
        "auto_crud": true,
        "breadcrumb": "Surgery",
        "showMenu": false
      },
      {
        "name": "menu.settled_surgery",
        "resource": "settled_surgery",
        "icon": "fa fa-user",
        "url": "settled_surgery",
        "auto_crud": true,
        "breadcrumb": "Surgery",
        "showMenu": false
      },
      {
        "name": "menu.billing_package_view",
        "resource": "billing_package_view",
        "icon": "fa fa-user",
        "url": "billing_package_view",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.billingPackage_detail_update",
        "resource": "billingPackage_detail_update",
        "icon": "fa fa-user-md",
        "url": "billingPackage_detail_update",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.billing_surgery_details",
        "resource": "billing_surgery_details",
        "icon": "fa fa-user",
        "url": "billing_surgery_details",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.billing_dashboard",
        "resource": "billingdashboard_format_dc",
        "icon": "fa fa-user",
        "url": "billingdashboard_format_dc",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "menu.billing_dashboard",
        "resource": "billingdashboard_format_er",
        "icon": "fa fa-user",
        "url": "billingdashboard_format_er",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "menu.billing_dashboard_er",
        "resource": "billing_details_billingdashboard_er",
        "icon": "fa fa-user",
        "url": "billing_details_billingdashboard_er",
        "auto_crud": true,
        "breadcrumb": "Billing Dashboard",
        "check_permission": false
      },
      {
        "name": "menu.service_type",
        "resource": "service_type_format",
        "icon": "fa fa-user",
        "url": "service_type_format",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.return_grid",
        "resource": "return_grid",
        "icon": "fa fa-user",
        "url": "return_grid",
        "auto_crud": true,
        "showMenu": false
      },
      {
        "name": "menu.issue_grid",
        "resource": "issue_grid",
        "icon": "fa fa-user",
        "url": "issue_grid",
        "auto_crud": true,
        "showMenu": false
      },
      {
        name: 'menu.authorization_details',
        resource: 'authorization_details',
        icon: 'fa fa-user',
        url: 'authorization_details',
        auto_crud: true,
        showMenu: false
      },
      {
        "name": "menu.service_type",
        "resource": "service_type_equipment",
        "icon": "fa fa-user",
        "url": "service_type_equipment",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.billing_counselling",
        "resource": "billing_counselling",
        "icon": "fa fa-user",
        "url": "billing_counselling",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.billing_counselling_detail",
        "resource": "billing_counselling_detail",
        "icon": "fa fa-user",
        "url": "billing_counselling_detail",
        "auto_crud": true,
        "check_permission": false
      },
      {
        name: 'menu.case_wise_patients',
        resource: "case_wise_patients",
        icon: 'fa fa-h-square',
        url: 'case_wise_patients',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.due_bills_utility',
        resource: "due_bills_utility",
        icon: 'fa fa-h-square',
        url: 'due_bills_utility',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.uhid_advance',
        resource: "patient_uhid_advance",
        icon: 'fa fa-h-square',
        url: 'patient_uhid_advance',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_bill_wise_pending',
        resource: "payout_bill_wise_pending",
        icon: 'fa fa-h-square',
        url: 'payout_bill_wise_pending',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayout_format',
        resource: "doctorpayout_format",
        icon: 'fa fa-h-square',
        url: 'doctorpayout_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayout_format_op',
        resource: "doctorpayout_format_op",
        icon: 'fa fa-h-square',
        url: 'doctorpayout_format_op',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayout_format_dc',
        resource: "doctorpayout_format_dc",
        icon: 'fa fa-h-square',
        url: 'doctorpayout_format_dc',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayout_format_er',
        resource: "doctorpayout_format_er",
        icon: 'fa fa-h-square',
        url: 'doctorpayout_format_er',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_bill_wise_posting',
        resource: "payout_bill_wise_posting",
        icon: 'fa fa-h-square',
        url: 'payout_bill_wise_posting',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayoutfinalposting_format',
        resource: "doctorpayoutfinalposting_format",
        icon: 'fa fa-h-square',
        url: 'doctorpayoutfinalposting_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayout_details',
        resource: "doctorpayout_details",
        icon: 'fa fa-h-square',
        url: 'doctorpayout_details',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.billing_trn_sap',
        icon: 'fa fa-tag',
        resource: 'billing_trn_sap',
        url: 'billing_trn_sap',
        auto_crud: true
      },
      {
        name: 'menu.doctorpayoutconfirmation_format',
        resource: "doctorpayoutconfirmation_format",
        icon: 'fa fa-h-square',
        url: 'doctorpayoutconfirmation_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayoutunitwise_format',
        resource: "doctorpayoutunitwise_format",
        icon: 'fa fa-h-square',
        url: 'doctorpayoutunitwise_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctorpayoutunitverified_format',
        resource: "doctorpayoutunitverified_format",
        icon: 'fa fa-h-square',
        url: 'doctorpayoutunitverified_format',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_pending',
        resource: "payout_doctor_wise_pending",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_pending',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_pending_details',
        resource: "payout_doctor_wise_pending_details",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_pending_details',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_posting_details',
        resource: "payout_doctor_wise_posting_details",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_posting_details',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_completed',
        resource: "payout_doctor_wise_completed",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_completed',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_posting',
        resource: "payout_doctor_wise_posting",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_posting',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.payout_doctor_wise_verified',
        resource: "payout_doctor_wise_verified",
        icon: 'fa fa-h-square',
        url: 'payout_doctor_wise_verified',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.doctor_wise_item_detail_completed',
        resource: "doctor_wise_item_detail_completed",
        icon: 'fa fa-h-square',
        url: 'doctor_wise_item_detail_completed',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        name: 'menu.case_wise_patient',
        resource: "case_wise_patient",
        icon: 'fa fa-h-square',
        url: 'case_wise_patient',
        check_permission: false,
        auto_crud: true,
        showMenu: true
      },
      {
        "name": "menu.billing_category_details",
        "resource": "billing_category_details",
        "icon": "fa fa-user",
        "url": "billing_category_details",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.billing_document_upload",
        "resource": "document_billing_new",
        "icon": "fa fa-user",
        "url": "document_billing_new",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.billing_surgery_details_package",
        "resource": "billing_surgery_details_package",
        "icon": "fa fa-user",
        "url": "billing_surgery_details_package",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.billing_auth_request",
        "resource": "billing_auth_request",
        "icon": "fa fa-user",
        "url": "billing_auth_request",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.ip_advance_payment",
        "resource": "ip_advance_payment",
        "icon": "fa fa-user",
        "url": "ip_advance_payment",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": "menu.ip_advance_payment",
        "resource": "advance_history_view",
        "icon": "fa fa-user",
        "url": "advance_history_view",
        "auto_crud": true,
        "check_permission": false
      },
       {
        "name": "menu.ip_advance_payment",
        "resource": "counselling_draft",
        "icon": "fa fa-user",
        "url": "counselling_draft",
        "auto_crud": true,
        "check_permission": false
      },
      {
        "name": 'menu.view_billing_payer_authorization',
        "resource": "view_billing_payer_authorization",
        "url": 'view_billing_payer_authorization',
        "auto_crud": true,
        "breadcrumb": 'View Billing Payer Authorization Details',
        "showMenu": true
      }
    ]
  }
]
